export default {
	title: '我的资料',
	messages: {
		choose_plan: '选择方案',
		unlock_immediately: '立即解锁全部功能',
		current_subscription: '您当前的订阅'
	},
	language: {
		title: '语言',
		description: '选择界面语言',
		languages: {
			de: '德语',
			en: '英语',
			es: '西班牙语',
			fr: '法语',
			hi: '印地语',
			it: '意大利语',
			ja: '日语',
			pt: '葡萄牙语',
			zh: '中文（普通话）'
		}
	},
	theme: {
		title: '主题'
	},
	actions: {
		manage_subscription: '管理我的订阅'
	},
	api_access: {
	  title: "API 访问（MCP 服务器）",
	  description: "允许 AI 代理（Claude、ChatGPT 等）通过 Model Context Protocol 访问您的 Gerositus 项目。该令牌授予与您相同的访问权限——请保密。",
	  endpoint: "MCP 端点 URL",
	  no_token: "尚无令牌——生成一个以启用 AI 代理访问。",
	  default_token_name: "默认令牌",
	  status_active: "活动",
	  status_revoked: "已撤销",
	  created_at: "创建于 {{date}}",
	  last_used_at: "最后使用 {{date}}",
	  never_used: "尚未使用",
	  generate: "生成令牌",
	  regenerate: "续期令牌",
	  revoke: "撤销令牌",
	  copy: "复制",
	  copied: "已复制到剪贴板",
	  copy_failed: "复制失败",
	  config_example: "MCP 客户端配置示例",
	  reveal_title: "立即保存您的令牌",
	  reveal_done: "我已保存",
	  reveal_warning_title: "这是您唯一能看到此令牌的机会",
	  reveal_warning_body: "请复制到安全的地方（密码管理器）。如果丢失需要续期。任何持有此令牌者都可读取您的项目。",
	  regenerate_confirm_title: "续期访问令牌？",
	  regenerate_confirm_body: "当前令牌将立即被撤销并签发新令牌。使用旧令牌的 AI 代理需要重新配置。",
	  revoke_confirm_title: "撤销访问令牌？",
	  revoke_confirm_body: "使用此令牌的 AI 代理将失去访问权限。您可以随时生成新令牌。"
	}
};
